interface FolderNode {
  id: string
  documentCount: number
  children?: FolderNode[]
}

export interface FolderContentStats {
  subfolderCount: number
  documentCount: number
}

export function computeFolderContentStats(folder: FolderNode): FolderContentStats {
  let subfolderCount = 0
  let documentCount = folder.documentCount

  const countChildren = (children: FolderNode[]) => {
    for (const child of children) {
      subfolderCount++
      documentCount += child.documentCount
      if (child.children) {
        countChildren(child.children)
      }
    }
  }

  if (folder.children) {
    countChildren(folder.children)
  }

  return { subfolderCount, documentCount }
}

export function findFolderInTree(folders: FolderNode[], targetId: string): FolderNode | null {
  for (const folder of folders) {
    if (folder.id === targetId) return folder
    if (folder.children) {
      const found = findFolderInTree(folder.children, targetId)
      if (found) return found
    }
  }
  return null
}
